import { Color, ColorWithSize } from "./interface/Color"

export const FolderIcon: React.FC<ColorWithSize> = ({color, width, height}) => {
    return (
        <svg width={width ?? "20"} height={height ?? "20"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.6 5H4.4C3.63 5 3.007 5.61875 3.007 6.375L3 14.625C3 15.3813 3.63 16 4.4 16H15.6C16.37 16 17 15.3813 17 14.625V7.75C17 6.99375 16.37 6.375 15.6 6.375H10L8.6 5Z" fill={color}/>
        </svg>
    )
}
